/**
 * wnav-lib.js — Lightweight nav helper for WebMenu (agnostic).
 * Replaces any LPS nav-lib dependency.
 */
(function (global) {
  'use strict';

  var WNav = {
    init: function (opts) {
      opts = opts || {};
      var btnId = opts.mobileMenuBtn || 'mobileMenuBtn';
      var menuId = opts.mobileMenu || 'mobileMenu';
      var revealClass = opts.revealClass || 'reveal';

      var btn = document.getElementById(btnId);
      var menu = document.getElementById(menuId);
      if (btn && menu) {
        btn.addEventListener('click', function () {
          menu.classList.toggle('hidden');
        });
      }

      if (opts.anchorLinks !== false) {
        document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
          anchor.addEventListener('click', function (e) {
            var href = anchor.getAttribute('href');
            if (!href || href === '#') return;
            var target = document.querySelector(href);
            if (target) {
              e.preventDefault();
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
              if (menu && !menu.classList.contains('hidden')) {
                menu.classList.add('hidden');
              }
            }
          });
        });
      }

      if (revealClass && 'IntersectionObserver' in global) {
        var reduced = false;
        try {
          reduced = global.matchMedia('(prefers-reduced-motion: reduce)').matches;
        } catch (e) {}
        if (reduced) {
          document.querySelectorAll('.' + revealClass).forEach(function (el) {
            el.classList.add('visible');
          });
        } else {
          var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) entry.target.classList.add('visible');
            });
          }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
          document.querySelectorAll('.' + revealClass).forEach(function (el) {
            observer.observe(el);
          });
        }
      }
    }
  };

  global.WNav = WNav;
})(window);
